import useAppSelector from '../../../store/hooks/useAppSelector'
import { authCustomerIsLoggedInSelector } from '../../auth/store/authSelectors'
import {
  clientContextHasCompanyProfilesSelector,
  clientContextIsCompanyUserSelector,
} from '../../clientContext/store/clientContextSelectors'

/**
 * True for a signed-in user on the private profile who also has a company
 * profile, so they can be hinted that they may be on the wrong profile.
 * Users without a company profile are never nudged.
 */
export default function useShowCompanyProfileNudge() {
  const isLoggedIn = useAppSelector(authCustomerIsLoggedInSelector)
  const hasCompanyProfiles = useAppSelector(
    clientContextHasCompanyProfilesSelector,
  )
  const isCompanyUser = useAppSelector(clientContextIsCompanyUserSelector)

  return !!isLoggedIn && hasCompanyProfiles && !isCompanyUser
}
